import {
  compact as _compact,
  isEmpty as _isEmpty,
  join as _join,
  values as _values
} from "lodash";
import STATE from "Constants/campaign/civicactioncenter/state";

const ALL_REQUIRED_FORM_FIELDS = [
  "title",
  "firstName",
  "lastName",
  "address1",
  "zip5",
  "phone",
  "email"
];

export default {
  namespaced: true,
  state: {
    advocateRecord: {},
    formValues: {
      subscribeEmail: true,
      subscribeSms: true,
      postOnOwnWall: true,
      shareWithFollowers: true
    },
    honeypotPageLoadTime: null,
    [STATE.CUSTOM_FIELDS]: {},
    [STATE.STARTED_FILLING_FORM]: false,
    [STATE.OPTIONAL_FIELDS]: {},
    validationResults: {}
  },
  mutations: {
    advocateRecord: (state, advocateRecordObject) => {
      state.advocateRecord = advocateRecordObject;
    },
    formValues: (state, valuesObject) => {
      state.formValues = {
        ...state.formValues,
        [valuesObject.fieldName]: valuesObject.value
      };
    },
    [STATE.CUSTOM_FIELDS](state, value) {
      state[STATE.CUSTOM_FIELDS] = value;
    },
    [STATE.STARTED_FILLING_FORM](state, value) {
      state[STATE.STARTED_FILLING_FORM] = value;
    },
    [STATE.OPTIONAL_FIELDS](state, value) {
      state[STATE.OPTIONAL_FIELDS] = value;
    },
    validationResults: (state, validationResultsObject) => {
      const currentAction = validationResultsObject.action;
      const currentActionValidationResults =
        state.validationResults[currentAction] || {};

      currentActionValidationResults[validationResultsObject.fieldName] =
        validationResultsObject.value;

      state.validationResults = {
        ...state.validationResults,
        [currentAction]: currentActionValidationResults
      };
    },
    honeypotPageLoadTime(state, value) {
      state.honeypotPageLoadTime = value;
    },
  },
  actions: {
    advocateRecord({ commit }, advocateRecordObject) {
      commit("advocateRecord", advocateRecordObject);
    },
    formValues({ commit }, valuesObject) {
      commit("formValues", valuesObject);
    },
    [STATE.CUSTOM_FIELDS]({ commit }, customFieldsObject) {
      commit(STATE.CUSTOM_FIELDS, customFieldsObject);
    },
    [STATE.STARTED_FILLING_FORM]({ commit }) {
      commit(STATE.STARTED_FILLING_FORM, true);
    },
    [STATE.OPTIONAL_FIELDS]({ commit }, optionalFieldsObject) {
      commit(STATE.OPTIONAL_FIELDS, optionalFieldsObject);
    },
    validationResults({ commit }, validationResultsObject) {
      commit("validationResults", validationResultsObject);
    },
    honeypotPageLoadTime({ commit }, value) {
      commit("honeypotPageLoadTime", value);
    },
  },
  getters: {
    advocateRecord(state) {
      return state.advocateRecord;
    },
    [STATE.ERROR](state, getters, rootState, rootGetters) {
      const validationErrorMsgContext = `${STATE.SCOPE_CAC}/${
        STATE.VALIDATION_ERROR_MSG
        }`;

      const validationError = rootGetters[validationErrorMsgContext];

      if (!_isEmpty(validationError)) {
        return `${_join(validationError, ". ")}.`;
      }

      const validationResults = _compact(
        _values(state.validationResults.default)
      );

      if (!_isEmpty(validationResults)) {
        return `${_join(validationResults, ". ")}.`;
      }

      return "";
    },
    [STATE.FORM_VALID](state, getters) {
      const { formValues } = state;
      const error = getters[STATE.ERROR];
      return (
        _isEmpty(error) &&
        ALL_REQUIRED_FORM_FIELDS.every(key => !_isEmpty(formValues[key]))
      );
    },
    [STATE.CUSTOM_FIELDS](state) {
      return state[STATE.CUSTOM_FIELDS];
    },
    [STATE.OPTIONAL_FIELDS](state) {
      return state[STATE.OPTIONAL_FIELDS];
    },
    [STATE.SHOW_SUBSCRIBE_EMAIL](state, getters, rootState) {
      return rootState.campaign.subscribeEmail && state[STATE.OPTIONAL_FIELDS].email;
    },
    [STATE.SHOW_SUBSCRIBE_SMS](state, getters, rootState) {
      return rootState.campaign.subscribeSms && state[STATE.OPTIONAL_FIELDS].phone;
    },
    formValues(state) {
      return state.formValues;
    },
    validationResults(state) {
      return state.validationResults;
    },
    advocatePayload(state) {
      let name = state.formValues.fullName;

      if (typeof state.formValues.fullName === "undefined") {
        // attempt to build full name if we have the pieces
        if (
          typeof state.formValues.firstName !== "undefined" &&
          typeof state.formValues.lastName !== "undefined"
        ) {
          name = `${state.formValues.firstName} ${state.formValues.lastName}`;
        }

        if (!_isEmpty(state.formValues.suffix)) {
          name = `${name} ${state.formValues.suffix}`;
        }
      }

      const filledCustomFields = {}
      Object.keys(state.customFields).forEach(field => {
        if (field in state.formValues) {
          filledCustomFields[state.customFields[field].id] = state.formValues[field];
        }
      });

      let devices = {};

      if (state.formValues.phone) {
        devices.phone = {
          address: state.formValues.phone,
          subscribed: state.formValues.subscribeSms
        }
      }

      if (state.formValues.email) {
        devices.email =  {
          address: state.formValues.email,
          subscribed: state.formValues.subscribeEmail
        }
      }

      let address = {
        address1: state.formValues.address1,
        zip5: state.formValues.zip5,
        zipcode: state.formValues.zipcode ? state.formValues.zipcode : state.honeypotPageLoadTime
      };

      if (state.formValues.address) {
        address.address = state.formValues.address;
      }

      return {
        name,
        title: state.formValues.title,
        identifiers: {
          phone: state.formValues.phone,
          email: state.formValues.email
        },
        address: address,
        devices,
        customFields: filledCustomFields,
      };
    }
  }
};